import React from "react";
import classNames from "classnames";
import buttons from "./../buttons.module.scss";
import {InlineLoader} from "./../Loaders";
import styles from "./ActionButton.module.scss";


export default ({isSubmitting, disabled, className, children, ...rest}) => {
  return <button disabled={isSubmitting || disabled} className={classNames(buttons.primary, styles.base, className)} type="submit" {...rest}>
      {isSubmitting ? <InlineLoader color="on-color"/> : children}
  </button>
};